function convertBoldProperties(oldItem) {
    let newObj = { properties: {} };
    for (const prop in oldItem) {
        if (`${prop}`.includes('properties[')) {
            newObj.properties[`${prop}`.substring(`${prop}`.indexOf("[") + 1, `${prop}`.lastIndexOf("]"))] = `${oldItem[prop]}`
        } else {
            newObj[`${prop}`] = `${oldItem[prop]}`;
        }
    }
    return newObj;
}

class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // Use cart-drawer
        this.cartDrawer = document.querySelector('cart-drawer');
    }

    async onSubmitHandler(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const cartDrawer = document.querySelector('cart-drawer');
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const cartRes = await fetch('/?section_id=cart-drawer');
            const cartHtml = await cartRes.text();

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cartHtml;

            const newDrawerContent = tempDiv.querySelector('#CartDrawer-Body');
            const drawerBody = cartDrawer.querySelector('#CartDrawer-Body');

            if (newDrawerContent && drawerBody) {
                drawerBody.innerHTML = newDrawerContent.innerHTML;
                cartDrawer.open();
            }
        } catch (error) {
            console.error('Error processing form data:', error);
            return;
        }
    }

}

customElements.define('product-form', ProductForm);
